import { Button } from '@aws-amplify/ui-react';
import { ActivityFeedItem } from '../services/pusher.service';
import { FeedItem } from './FeedItem';
import './FeedList.scss';

interface FeedListProps {
  items: ActivityFeedItem[];
  newItemIds?: Set<string>;
  hasMore?: boolean;
  isLoadingMore?: boolean;
  onLoadMore?: () => void;
}

export function FeedList({ items, newItemIds, hasMore, isLoadingMore, onLoadMore }: FeedListProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="feed-list">
      {items.map((item) => (
        <FeedItem key={item.id} item={item} isNew={newItemIds?.has(item.id)} />
      ))}
      {hasMore && onLoadMore && (
        <div className="feed-list__load-more">
          <Button size="small" className="silent" onClick={onLoadMore} isLoading={isLoadingMore}>
            Load More
          </Button>
        </div>
      )}
    </div>
  );
}
